import _ from 'lodash';

export const documentTypes = [
	{
		display: 'Driver Ticket',
		value: 'driverTicket',
	},
	{
		display: 'Veeder Root',
		value: 'veederRoot',
	},
	{
		display: 'Loading BOL',
		value: 'loadingBol',
	},
	{
		display: 'Offloading BOL',
		value: 'offloadingBol',
	},
	{
		display: 'DER',
		value: 'der',
	},
	{
		display: '1018',
		value: '1018',
	},
	{
		display: 'Misc Docs',
		value: 'misc',
	},
];

// const docTypeDisplayToValue = {}:
//documentTypes.forEach ({{ display, value}}) => {

export const docTypeDisplayToValue = _.mapValues(_.keyBy(documentTypes, 'value'), 'display');
